export enum TabName {
  TOPICS = 'Topics',
  REPORTERS = 'Reporters',
}
